// extracted by mini-css-extract-plugin
module.exports = {"separator":"style_separator__2F7DH"};